import React, { useState, useEffect } from "react";
import { Text, TextDescription } from "./Texts";
import moment from "moment";
import { useTranslation } from "react-i18next";
import useWindowSize from "../layout/useWindowSize";

import Column from "./Column";
import Dropdown from "./Dropdown";
import Icon from "./Icon";
import PropTypes from "prop-types";
import Row from "./Row";
import Section from "./Section";
import styled from "styled-components";
// import _find from 'lodash/find'

// import { useSelector } from 'react-redux'

// import mainSelectors from '../modules/main/selectors'

const DatePicker = ({ items, onSelected, defaultIndex = 0 }) => {
  const [t] = useTranslation();
  const windowSize = useWindowSize();
  // const currentAd = useSelector(state => mainSelectors.currentAd(state))
  // const authAdproResult = useSelector(state => mainSelectors.authAdproResult(state))
  // const updateTime = _find(authAdproResult.data.ads, { ads_account_id: currentAd.ads_account_id }).update_time
  const today = moment();
  console.log("DatePicker", today);
  if (today.hour() < 7) {
    today.hour(0);
  } else if (today.hour() < 13) {
    today.hour(7);
  } else if (today.hour() < 19) {
    today.hour(13);
  } else {
    today.hour(19);
  }
  today.minute(0);
  today.second(0);

  const dateOption = items
    ? items
    : [
        {
          key: "today",
          title: t("__today"),
          value: {
            start: moment().format("YYYY-MM-DD"),
            end: moment().format("YYYY-MM-DD"),
          },
          previous: {
            start: moment().add(-1, "days").format("YYYY-MM-DD"),
            end: moment().add(-1, "days").format("YYYY-MM-DD"),
          },
          view: "daily",
          description: today.format("D MMM YYYY HH:mm"),
        },
        {
          key: "yesterday",
          title: t("__yesterday"),
          value: {
            start: moment().add(-1, "days").format("YYYY-MM-DD"),
            end: moment().add(-1, "days").format("YYYY-MM-DD"),
          },
          previous: {
            start: moment().add(-2, "days").format("YYYY-MM-DD"),
            end: moment().add(-2, "days").format("YYYY-MM-DD"),
          },
          view: "daily",
          description: moment().add(-1, "days").format("D MMM YYYY"),
        },
        {
          key: "last_7d",
          title: t("__last_7_days"),
          value: {
            start: moment().add(-7, "days").format("YYYY-MM-DD"),
            end: moment().add(-1, "days").format("YYYY-MM-DD"),
          },
          previous: {
            start: moment().add(-14, "days").format("YYYY-MM-DD"),
            end: moment().add(-8, "days").format("YYYY-MM-DD"),
          },
          view: "summary",
          description: `${moment().add(-7, "days").format("D MMM YYYY")} - ${moment().add(-1, "days").format("D MMM YYYY")}`,
        },
        {
          key: "last_week_mon_sun",
          title: t("__last_week"),
          value: {
            start: moment().subtract(1, "weeks").startOf("isoWeek").format("YYYY-MM-DD"),
            end: moment().subtract(1, "weeks").endOf("isoWeek").format("YYYY-MM-DD"),
          },
          previous: {
            start: moment().subtract(2, "weeks").startOf("isoWeek").format("YYYY-MM-DD"),
            end: moment().subtract(2, "weeks").endOf("isoWeek").format("YYYY-MM-DD"),
          },
          view: "summary",
          description: `${moment().subtract(1, "weeks").startOf("isoWeek").format("D MMM YYYY")} - ${moment().subtract(1, "weeks").endOf("isoWeek").format("D MMM YYYY")}`,
        },
        {
          key: "last_30d",
          title: t("__last_30_days"),
          value: {
            start: moment().add(-30, "days").format("YYYY-MM-DD"),
            end: moment().add(-1, "days").format("YYYY-MM-DD"),
          },
          previous: {
            start: moment().add(-60, "days").format("YYYY-MM-DD"),
            end: moment().add(-31, "days").format("YYYY-MM-DD"),
          },
          view: "summary",
          description: `${moment().add(-30, "days").format("D MMM YYYY")} - ${moment().add(-1, "days").format("D MMM YYYY")}`,
        },
        {
          key: "last_month",
          title: t("__last_month"),
          value: {
            start: moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
            end: moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
          },
          previous: {
            start: moment().subtract(2, "month").startOf("month").format("YYYY-MM-DD"),
            end: moment().subtract(2, "month").endOf("month").format("YYYY-MM-DD"),
          },
          view: "summary",
          description: `${moment().subtract(1, "month").startOf("month").format("D MMM YYYY")} - ${moment().subtract(1, "month").endOf("month").format("D MMM YYYY")}`,
        },
      ];
  const [selectedItem, setSelectedItem] = useState();

  useEffect(() => {
    console.log("selectedItem changed", selectedItem, defaultIndex);
    onSelected(selectedItem || dateOption[defaultIndex]);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);

  const pickerButton = ({ onClick }) => (
    <StyledDatePicker onClick={onClick}>
      <ManageColumn>
        <Text align="left">
          {selectedItem ? selectedItem.title : dateOption ? dateOption[defaultIndex].title : "-"}
        </Text>
        <TextDescription align="left">
          {selectedItem ? selectedItem.description : dateOption ? dateOption[defaultIndex].description : "-"}
        </TextDescription>
      </ManageColumn>
      <PositionColumn wrap>
        <Icon name="icon-down-dir"></Icon>
      </PositionColumn>
    </StyledDatePicker>
  );

  return (
    <StyledDropdown windowSize={windowSize.width}>
      <Dropdown
        CustomDropdownButton={pickerButton}
        items={dateOption}
        onSelected={setSelectedItem}
        minWidth="300px"
        position={{ top: "72px" }}
        defaultIndex={defaultIndex}
      />
    </StyledDropdown>
  );
};

DatePicker.propTypes = {
  items: PropTypes.array,
  onSelected: PropTypes.func,
};

export default DatePicker;

const StyledDatePicker = styled(Section)`
  width: 300px;
  margin: 0 0 24px;
  min-height: 72px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  & i {
    font-size: 24px;
    margin-right: -8px;
  }

  @media screen and (max-width: 834px) {
    text-align: left;
    width: 100%;
  }
`;

const ManageColumn = styled(Column)`
  margin-left: 0px;
  margin-right: 0px !important;
`;

const PositionColumn = styled(Column)`
  position: absolute;
  left: 260px;
  @media screen and (max-width: 834px) {
    left: unset;
    right: 16px;
  }
`;

const StyledDropdown = styled.div.attrs((props) => ({
  display: props.windowSize > 834 ? "flex" : "block",
  width: props.windowSize > 834 ? "auto" : "auto",
  JustifyContent: props.windowSize > 834 ? "flex-end" : null,
}))`
  display: ${(props) => props.display};
  width: ${(props) => props.width};
  justify-content: ${(props) => props.JustifyContent};
`;
